import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "es-right-bar ptop-15" }
const _hoisted_2 = { class: "row pbottom-02 ptop-04 title-adjust" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "list" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "line-h mtop-02 mleft-10",
  style: {"margin-bottom":"0.2rem","width":"15rem"}
}
const _hoisted_7 = { class: "list" }

import addTtt from './addTtt.vue'
import editMedicDoseUpper from "../editMedic/editMedicDoseUpper.vue"
import editMedicDoseLower from "../editMedic/editMedicDoseLower.vue"

import { ref, computed, onMounted, watch } from 'vue'
import { sortMedicExprArray} from '@/functions/expression'
import { useCurrentEntryStore } from '@/stores/currentEntry'
import { useUiStore } from '@/stores/ui'
import gen from "@/functions/general"
import SharedService from "@/services/SharedService";
import { useI18n } from "vue-i18n";
import { parseFavorite, emptyParsedDose} from '@/functions/dosageUtils'
import { FolderPatientApi, PatientTreatmentResponse } from '@/apiGenerate/medserver'
import { medServerApiConfig } from '@/config/medserver-api.config'
import { useRoute } from 'vue-router'
import { getSingleElement } from '@/utils/array-utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'rBarTtt',
  props: {
    reloadPatientData: { type: Boolean }
  },
  emits: ['setReloadPatientData'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const currentEntryStore = useCurrentEntryStore()
const uiStore = useUiStore()
const { t } = useI18n();
const route = useRoute();

const emits = __emit;

const folderPatientApi = new FolderPatientApi(medServerApiConfig);

const patientTreatmentResponse = ref<PatientTreatmentResponse[]>([]);

const dropd = ref("");

async function openAddTtt() {
  currentEntryStore.allExpressions = await folderPatientApi.getAlertExpressions({
    patientId : currentEntryStore.currentPatientId});
  uiStore.setModalUiId("addTtt")
}

const isEditable = computed(() => {
  return currentEntryStore.isEditable && !currentEntryStore.currentEntry.archivedByUser;
});

const firstTttWithEndIndex = computed(() => {
  return patientTreatmentResponse.value.findIndex(item => item.durationType !== 'Since');
});

//Drag 'N Drop
const isDraggingOverTtt = ref(false)

function onDragOverTtt() {
  if (currentEntryStore.dndType !== 'exprTtt') {
    isDraggingOverTtt.value = true
  }  
}

function onDragLeaveTtt() {
  isDraggingOverTtt.value = false
}

async function onDropOnTtt() {
  isDraggingOverTtt.value = false;
  const dndType = currentEntryStore.dndType;
  const dndObject = currentEntryStore.dndObject;
  currentEntryStore.clearDnd();
  if (dndType !== 'exprTtt') {
    const conclusionId = dndObject.conclusionGroup.conclusionGroupId;
    const sapName = dndObject.matchedText;
    const parsedDoses = dndObject.unMatchedText ? parseFavorite(dndObject.unMatchedText) : [emptyParsedDose()];
    const sctSubstanceKey = dndObject.sctSubstanceKey;
     console.log("onDropOnTtt = ", parsedDoses)
    await currentEntryStore.createNewSapExpr(conclusionId, sapName, '', '', parsedDoses, sctSubstanceKey);
    await loadTreatment();
    currentEntryStore.reloadAfterMedicationChange();
  }
}

function medicAction(expr: PatientTreatmentResponse) {
  currentEntryStore.setPoppedSapExpr(expr);
  currentEntryStore.setCurrSuggestionsForDashboard(null);
  uiStore.setDashBoardItem(expr);
}

function evolveMedic(expr: PatientTreatmentResponse) {
  currentEntryStore.setPoppedSapExpr(expr);  
  dropd.value = "EditMedic" + expr.id.ui
}

async function closeFct() {
  dropd.value = "";
}

const loadTreatment = () => {
  folderPatientApi.getTreatmentByPatient({ patientId: getSingleElement(route.params.patientId) }).then((result: PatientTreatmentResponse[]) => {
     patientTreatmentResponse.value = result;

    // Sort
    sortMedicExprArray(patientTreatmentResponse.value)

    //Add UIs (AFTER sort)
    let uiIndex = 0
    patientTreatmentResponse.value.forEach(sapExpr => {
      sapExpr.id = gen.newId("rBarTtt", ++uiIndex)
    });

    emits('setReloadPatientData');
  });
};

watch(
  () => props.reloadPatientData,
  async () => {
    if (props.reloadPatientData) {
      await loadTreatment();
    }   
  }
);

onMounted(async () => {
  await loadTreatment();
});

return (_ctx: any,_cache: any) => {
  const _component_es_button = _resolveComponent("es-button")!
  const _component_es_button_icon = _resolveComponent("es-button-icon")!
  const _component_itemModal = _resolveComponent("itemModal")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup2 = _resolveComponent("listGroup2")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_buttonGroup = _resolveComponent("buttonGroup")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onDragover: _withModifiers(onDragOverTtt, ["prevent"]),
      onDragleave: onDragLeaveTtt,
      onDrop: _withModifiers(onDropOnTtt, ["prevent"]),
      class: _normalizeClass([isDraggingOverTtt.value ? 'bigshadow' : ''])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "mleft-08" }, null, -1)),
          _createVNode(_component_es_button, {
            label: _unref(t)('patient.rightBar.subtitle.treatment'),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(uiStore).setDashBoardType('Medic'))),
            "is-primary": false,
            "is-linked": true
          }, null, 8, ["label"]),
          (isEditable.value)
            ? (_openBlock(), _createBlock(_component_es_button_icon, {
                key: 0,
                icon: "plus",
                folder: "shareIcons",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (openAddTtt())),
                styles: "icon-grey-style square-14",
                class: "square-29 justify-center"
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_itemModal, {
            center: true,
            uiId: "addTtt"
          }, {
            modal: _withCtx(() => [
              _createVNode(addTtt, {
                class: "item-modal",
                treatmentAdded: loadTreatment
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_listGroup2, {
          class: "row mleft-10 gap-02",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(uiStore).setDashBoardType('Vacc')))
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _unref(SharedService).getIcon('exclamationmark-triangle', false, 'rightBar'),
              class: "w-12 h-12"
            }, null, 8, _hoisted_5),
            _createVNode(_component_text_item, {
              txt: _unref(t)('patient.rightBar.vaccine'),
              class: "pad-s max-w-260"
            }, null, 8, ["txt"])
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(patientTreatmentResponse.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (index === firstTttWithEndIndex.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_listGroup2, {
              class: "row mleft-10 full-row",
              onClick: ($event: any) => (medicAction(item))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_text_item, {
                  txt: item.text + ' ',
                  class: "pad-s item-medic",
                  ellipsis: true
                }, null, 8, ["txt"]),
                _createVNode(_component_text_item, {
                  txt: item.posoText,
                  class: "main-l pad-s item-poso mleft-02",
                  ellipsis: true
                }, null, 8, ["txt"]),
                (isEditable.value)
                  ? (_openBlock(), _createBlock(_component_buttonGroup, {
                      key: 0,
                      styles: "pad-s",
                      class: "psides-04",
                      onClick: _withModifiers(($event: any) => (evolveMedic(item)), ["stop"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_svg_item, {
                          icon: "moreVertical",
                          styles: "size-l main-l"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_dropdownBox, {
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
                  openOn: 'EditMedic' + item.id.ui,
                  combo: true
                }, {
                  dropup: _withCtx(() => [
                    _createVNode(editMedicDoseUpper)
                  ]),
                  dropd: _withCtx(() => [
                    _createVNode(editMedicDoseLower, {
                      conclusionId: null,
                      onTreatmentUpdated: loadTreatment,
                      onClose: _cache[3] || (_cache[3] = ($event: any) => (closeFct()))
                    })
                  ]),
                  _: 2
                }, 1032, ["modelValue", "openOn"]),
                _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mleft-04" }, null, -1))
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ], 64))
      }), 128))
    ], 34)
  ]))
}
}

})